import React from 'react';

import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

interface DetailItemProps {
  title: string;
  value: string | React.ReactNode;
}

const DetailItem: React.FC<DetailItemProps> = ({ title, value }) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
      <Typography variant="body1">{title}</Typography>
      {React.isValidElement(value) ? (
        value
      ) : (
        <Typography variant="subtitle1" fontWeight={500}>
          {value}
        </Typography>
      )}
    </Stack>
  );
};

export default DetailItem;
